import { isEditor3Host } from '../utils/get-editor-host';
import { useA11yWizardAdapter } from './use-a11y-wizard-adapter';
export const useIsEditor3 = () => {
  const {
    editorHost
  } = useA11yWizardAdapter();
  return isEditor3Host(editorHost);
};
//# sourceMappingURL=use-is-editor3.js.map